/**
 * Provisioning API Client
 */
import { createApiClient } from '@shared/api-client'

// Create API client instance for provisioning
const apiClient = createApiClient({
  baseURL: import.meta.env.VITE_API_URL || 'http://localhost:8000',
  getToken: () => localStorage.getItem('token'),
  onUnauthorized: () => {
    localStorage.removeItem('token')
    window.location.href = '/login'
  },
})

export interface ProvisionOrganizationRequest {
  organization_name: string
  organization_domain: string
  admin_email: string
  admin_password: string
  admin_name: string
}

export interface ProvisioningStatus {
  job_id: string
  status: 'provisioning' | 'ready' | 'failed'
  instance_id?: string
  api_url?: string
  error?: string
  step?: string
}

export const provisioningApi = {
  /**
   * Provision a new organization instance
   */
  async provisionOrganization(
    data: ProvisionOrganizationRequest
  ): Promise<{ job_id: string; status: string; message: string }> {
    const response = await apiClient.post('/api/v1/provisioning/provision', data)
    return response.data
  },

  /**
   * Get provisioning status
   */
  async getProvisioningStatus(jobId: string): Promise<ProvisioningStatus> {
    const response = await apiClient.get(`/api/v1/provisioning/provision/${jobId}`)
    return response.data
  },

  /**
   * List all instances
   */
  async listInstances(): Promise<any[]> {
    const response = await apiClient.get('/api/v1/provisioning/instances')
    return response.data
  },

  /**
   * Get instance details
   */
  async getInstance(instanceId: string): Promise<any> {
    const response = await apiClient.get(`/api/v1/provisioning/instances/${instanceId}`)
    return response.data
  },

  /**
   * Destroy an instance
   */
  async destroyInstance(instanceId: string): Promise<void> {
    await apiClient.delete(`/api/v1/provisioning/instances/${instanceId}`)
  },
}

